import { IS_DEMO_MODE } from '@/utils/demoMode';
import { ScreenshotsComponent } from './Screenshots.component';
import { ScreenshotsDemoComponent } from './Screenshots.demo.component';

export const ScreenshotsPage = IS_DEMO_MODE
  ? ScreenshotsDemoComponent
  : ScreenshotsComponent;
